import { createSlice } from '@reduxjs/toolkit';


const initialState = {
    filter: "",
    search: "",
    sort: false,

}

const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        setFilter: (state, action)=>{
            state.filter = action.payload
        },
        setSearch: (state, action)=>{
            state.search = action.payload
        },
        setSort: (state, action)=>{
            state.sort = action.payload
        },
    }
})

export default filterSlice.reducer;
export const { setFilter, setSearch, setSort  } = filterSlice.actions;